import axios from "axios";
import { router } from "../router";
import store from "../store/store";

const recUrl = "https://chl-rec-engine.herokuapp.com";
// const recUrl = "http://localhost:3500";

axios.interceptors.request.use(config => {
  config.headers.common["Authorization"] = localStorage.CHLToken;
  return config;
});

axios.interceptors.response.use(config => {
  if (!config.data.success && config.data.message === "authentication failed") {
    if (!store.getters.loggedIn) {
      router.push("/loggedOut");
    }
  }
  return config;
});

export const authenticate = {
  exchangeToken(tmpToken, serviceId) {
    return axios.post(`${store.getters.authUrl}/tokenExchange`, { tmpToken, serviceId });
  },
  getThirdPartyToken(tokenName) {
    return axios.get("/api/thirdPartyToken", { params: { tokenName } });
  },
  organization() {
    return axios.get("/api/organization");
  },
};

export const user = {
  get(userId) {
    return axios.get(`${store.getters.authUrl}/api/user/${userId}`);
  },
};

export const search = {
  records(string, params) {
    return axios.get(`/api/search/${string}`, { params });
  },
  business(string) {
    return axios.get(`/api/searchBusiness/${string}`);
  },
  sampleNumber(sampleNumbers) {
    return axios.post("/api/search/sampleNumber", { sampleNumbers });
  },
};

export const location = {
  getCurrent(businessId) {
    return axios.get(`/api/location/${businessId}`);
  },
};

export const plot = {
  getCurrent(locationId) {
    return axios.get(`/api/plot/${locationId}`);
  },
};

export const series = {
  get(externalId) {
    return axios.get("/api/series", { params: { id: externalId } });
  },
};

export const report = {
  createUpdate(data) {
    return axios.post("/api/report", data);
  },
  get(params) {
    return axios.get("/api/report", { params });
  },
};

export const dataset = {
  createUpdate(data) {
    return axios.post("/api/dataset", data);
  },
  get(params) {
    return axios.get("/api/dataset", { params });
  },
  delete(externalId) {
    return axios.delete("/api/dataset", { params: { externalId } });
  },
};

export const statistics = {
  run(params) {
    return axios.get("/api/statistics", { params });
  },
};

export const range = {
  get(crop, name) {
    return rangeCache(`/api/range/${crop}/${name}`, `${crop}Range`, 172800000);
  },
  createUpdate(data) {
    return axios.post("/api/range", data);
  },
};

export const pdf = {
  createLinePdf(svg) {
    return axios.post("/api/svgToPdf", svg, { responseType: "blob" });
  },
};

export const sampleSet = {
  delete(setId) {
    return axios.delete("/api/sampleSet", { params: { setId } });
  },
  create(data) {
    return axios.post("/api/sampleSet", data);
  },
};

export const recommendation = {
  create(data) {
    return axios.post(`${recUrl}/api/createRec`, data);
  },
  save(data) {
    return axios.post(`${recUrl}/api/userGeneratedRec`, data);
  },
};

async function rangeCache(url, name, expiration = 14400000) {
  let ok = false;
  let results = {};

  if (localStorage[name]) {
    //check for cache
    try {
      results = JSON.parse(localStorage[name]);
      ok = !!(results.expiration > Date.now() && results.data && results.data.ranges);
      results = results.data;
    } catch (error) {
      ok = false;
    }
  }
  if (!ok) {
    const res = await axios.get(url);
    results = res.data;
    const store = {
      expiration: Date.now() + expiration,
      data: { ranges: res.data.ranges, aliases: res.data.aliases },
    };
    localStorage[name] = JSON.stringify(store);
  }
  return results;
}
